import { SelfServiceSchedulePaneProps, SelfServiceSchedulePaneType } from '@tableau/self-service-schedules/lib/src/components/SelfServiceSchedulePane';

import { IDataSourceDetailInfo } from '~src/datasource/models/IDataSourceInfo';
import { ChangeDatasourceRemoteRefreshPropertiesHelper, IRemoteRefreshAgentOption } from '~src/datasource/services/ChangeDatasourceRemoteRefreshPropertiesHelper';
import { RemoteRefreshAgents } from '~src/extractRefresh/resources/RemoteRefreshAgents';
import { IGetRemoteRefreshAgentsResult } from '~src/extractRefresh/serverApi/requests/remoteExtractRefresh/GetRemoteRefreshAgentsRequest';
import { ChangeScheduleActionService } from '~src/schedule/services/ChangeScheduleAction';

import { ISelfServiceScheduleDetails } from '../../../schedule/types/ISchedule';
import { ICreateExtractTasks } from '../CreateExtractTaskAction';

export namespace CreateBridgeExtractTaskActionService {

  export function getDefaultSelfServiceSchedulePanePropsForSSSWidget(remoteAgentTimeZone: string): SelfServiceSchedulePaneProps {

    const scheduleDetails: ISelfServiceScheduleDetails = {
      startTime: 300,
      endTime: 0,
      recurrenceMinutes: 1440,
      recurrenceDaysOfWeek: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      recurrenceDayOfMonth: '0',
    };

    const selfServiceSchedulePaneProps = ChangeScheduleActionService.getSelfServiceSchedulePaneProps(
      scheduleDetails, remoteAgentTimeZone != null, remoteAgentTimeZone, 'Weekly',
      SelfServiceSchedulePaneType.BridgeExtractRefresh);

    return selfServiceSchedulePaneProps;
  }

  export function setRemoteAgentOptionsInScope(datasource: IDataSourceDetailInfo, createExtractTasks: ICreateExtractTasks) {
    return RemoteRefreshAgents.get()
      .then((result: IGetRemoteRefreshAgentsResult) => {
        const remoteAgents = ChangeDatasourceRemoteRefreshPropertiesHelper.buildRemoteAgentsList(result, datasource);
        createExtractTasks.remoteAgentOptions = remoteAgents;
        return createExtractTasks;
      });
  }

  export function getRemoteAgentOptions(datasource: IDataSourceDetailInfo): Promise<IRemoteRefreshAgentOption[]> {
    return RemoteRefreshAgents.get()
      .then((result: IGetRemoteRefreshAgentsResult) => {
        return ChangeDatasourceRemoteRefreshPropertiesHelper.buildRemoteAgentsList(result, datasource);
      });
  }
}
